module.exports = __webpack_public_path__ + "img/carl-marbach.49243c92.jpg";